<div class="px-3 py-5 preference-card">
  <h4 class="fw-light fs-1 text-center head-title">
    {{"mnumanagepreferences" | translate}}
  </h4>
  <div class="text-center">
            <div class="ring" *ngIf="loading">
              Loading.
              <span class="span"></span>
            </div>           
          </div>

    <!-- Success Message -->
          
  <div class="row card-group py-2 px-3 pt-0">
    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="card" *ngIf="parsedData">
        <div class="card">

          <!-- Marketing Consent Section -->
          <form class="manage-consent marketing-consent">
            <label class="consent-label">
              <input type="radio" [checked]="isMarketingConsentChecked"
                (click)="onCheckboxConsentChange('isMarketingConsentChecked', ['isUnsubscribeConsentChecked'])"
                class="form-check-input">
              <span>
                {{"marketingconsent1" | translate}}
                <b> {{'marketingconsentbold' | translate}}</b>
                {{"marketingconsnet2" | translate}}
                <span *ngIf="!isMarketingConsentChecked">...{{"readmore" | translate}}</span>
                <span *ngIf="isMarketingConsentChecked" [@fadeIn]>
                  {{"marketingconsent3" | translate}}
                </span>
              </span>
            </label>
          </form>        


<div class="mx-3">
</div>
          <div class="mx-3" *ngIf="isMarketingConsentChecked">
            <form novalidate [formGroup]="phoneForm"> 
              <div class="ms-5">
                <div class="categories">{{"Categories" | translate}}</div>
                <div class="preferred-categories" *ngIf="showPreferredCategories " >{{"PleaseSelectCategories" | translate}}</div>
                <div class="row mt-3 ">
                  <div class="col-md-6 col-sm-12 col- col-sm-12 ">               
 
  <ng-container *ngFor="let subItem of parsedData['Marketing Consent (ECP)']">
    <ng-container *ngIf="getKey(subItem) === 'Communication Content'">
      <div class="sub-card-title alcon-text-color pt-4 fw-bold">
        <h6>{{ getKey(subItem) | translate }}</h6>
        <div *ngFor="let detail of subItem[getKey(subItem)]" class="form-check">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input mx-1" [checked]="getValue(detail)"
              (change)="onCheckboxChange(detail, subItem, getKey(subItem), $event)" />
            {{ getLabel(detail) | translate}}
          </label>
        </div>
      </div>
    </ng-container>
  </ng-container>
  
  <ng-container *ngFor="let subItem of parsedData['Marketing Consent (ECP)']">
    <ng-container *ngIf="getKey(subItem) === 'Communication Method'">
      <div class="sub-card-title alcon-text-color pt-4 fw-bold">
        <h6>{{ getKey(subItem) | translate }}</h6>
        <div *ngFor="let detail of subItem[getKey(subItem)]" class="form-check">
          <label class="form-check-label" *ngIf="getLabel(detail) !='Email'">
            <input type="checkbox" class="form-check-input mx-1" [checked]="getValue(detail)"
              (change)="onCheckboxChange(detail, subItem, getKey(subItem), $event)" />
            {{ getLabel(detail) | translate}}
          </label>
          <label class="form-check-label" *ngIf="getLabel(detail) === 'Email'">
            <input type="checkbox" class="form-check-input mx-1" [checked]="true" disabled

              (change)="onCheckboxChange(detail, subItem, getKey(subItem), $event)" />
            {{ getLabel(detail) | translate }}
          </label>
           <div class="wrapper" *ngIf="getLabel(detail) === 'Mobile Phone SMS'">
            
    <ngx-intl-tel-input *ngIf="getLabel(detail)==='Mobile Phone SMS'"
    #phoneInput
    type="text" [style]="'padding-left:0px;'"
      [cssClass]="'input-tel1 form-group form-control input-tel col-md-4 col-xl-4'"
      [preferredCountries]="preferredCountries"
      (countryChange)="onChangeCode($event)"
      [enableAutoCountrySelect]="true"
      [enablePlaceholder]="false"
      [searchCountryFlag]="true"
      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
      [selectFirstCountry]="false" 
      [selectedCountryISO]="SearchCountryISO"   
      [maxLength]="15"
      [phoneValidation]="true"
      [separateDialCode]="separateDialCode"
      [numberFormat]="PhoneNumberFormat.National"
      name="phone"
    
      [disabled]="true"
      formControlName="phone"
      (change)="onInput($event)"      
      (focus)="onFocus()"
      (blur)="onBlur()"
      (input)="onInput($event)"
      aria-describedby="button-addon2" required
    >
    </ngx-intl-tel-input>  

  <div *ngIf="invalidNo" class="error-text">
    <span class="bi bi-exclamation-circle-fill" aria-label="Error"></span>
    {{ 'entervalidphone' | translate }}
  </div>
</div>
        </div>
        </div>    
    
  </ng-container>
    </ng-container>

   <ng-container *ngFor="let subItem of parsedData['Marketing Consent (ECP)']; let i = index">
      <ng-container *ngIf="getKey(subItem) === 'Areas of Interest (ECP)'">
        <div class="sub-card-title alcon-text-color pt-4 fw-bold" >
          <h6>{{ getKey(subItem) | translate }}</h6>
          <ng-container *ngFor="let detail of subItem[getKey(subItem)]; let j = index">
            <div class="form-check" *ngIf="j < subItem[getKey(subItem)].length / 2">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input mx-1" [checked]="getValue(detail)"
                  (change)="onCheckboxChange(detail, subItem, getKey(subItem), $event)" />
                {{ getLabel(detail) | translate }}
              </label>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  <!-- Second Column: Second half of options -->
    <ng-container *ngFor="let subItem of parsedData['Marketing Consent (ECP)']; let i = index">
  <ng-container *ngIf="getKey(subItem) === 'Areas of Interest (ECP)'">
    <div class="sub-card-title alcon-text-color pt-4 fw-bold mobile_area">
      <h6></h6>
      <ng-container *ngFor="let detail of subItem[getKey(subItem)]; let j = index">
        <div class="form-check" *ngIf="j >= subItem[getKey(subItem)].length / 2">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input mx-1" [checked]="getValue(detail)"
              (change)="onCheckboxChange(detail, subItem, getKey(subItem), $event)" />
            {{ getLabel(detail) | translate }}
          </label>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>

                  </div>
                </div>

              </div>
            </form>
          </div>


          <!-- Unsubscribe Section -->
          <form class="manage-consent unsubscribe-consent">
            <label class="consent-label">
              <input type="radio" formControlName="consent" [checked]="isUnsubscribeConsentChecked"
                (change)="onCheckboxConsentChange('isUnsubscribeConsentChecked', ['isMarketingConsentChecked'])"
                class="form-check-input">
              <span>{{"unsubscribeconsent1" | translate}} <b>{{"unsubscribeBold" | translate}}</b> {{"unsubscribeconsent2" | translate}}<br><br>
                {{"unsubscribeconsent3" | translate}} <u><a class="privacy-policy-link"href="https://www.alcon.com/privacy-policy"  target="_blank">{{'privacynotices' | translate}}</a></u>
 & <u><a class="Terms-link" href="https://www.au.alcon.com/terms-use"  target="_blank">{{"termsofuse" | translate}}</a></u>.

              </span>
            </label>
          </form>

         
          <!-- Submit Button -->
          <div class="text-end">
            <input class="btn btn-primary" [ngClass]="{  'consentSubmit': enableSubmit  }"
 [disabled]="enableSubmit"  type="submit" [value]="'btnsubmit' | translate" (click)="onPreferenceWithConsentSubmit()" /> 
          </div>
            <div class="alert alert-success mx-3" *ngIf="consentFormSubmitted">
            <strong>{{"labelSuccess" | translate}} - </strong> {{"preferencesSuccessMsg" | translate}}
          </div>
          <div  class="alert  alert-danger mx-3"  *ngIf="consentFormError">
             <strong>{{"labelError" | translate}}  - </strong> {{"preferencesErrorMsg" | translate}}
              </div>

        </div>
      </div>
    </div>
  </div>
</div>